module.exports = __webpack_public_path__ + "static/media/projects_thumb_bkst_site_2x.a5a24cf0.jpg";